export default __webpack_public_path__ + "static/media/murray_esler.cf4b9ce8.jpg";